import humps from 'humps'

import {isEmpty} from 'lodash'
import api from '@/lib/api'

export default {
  namespaced: true,

  state: {
    requests: [],
    fields: [
      {key: 'id', label: 'ID', sortable: true},
      {key: 'eventName', label: 'Event', sortable: true},
      {key: 'eventSite', label: 'Site', sortable: true},
      {key: 'webkeyId', label: 'Webkey', sortable: true},
      {key: 'ipc', label: 'Type', sortable: true},
      {key: 'firstName', label: 'First Name', sortable: true},
      {key: 'lastName', label: 'Last Name', sortable: true},
      {key: 'country', label: 'Country', sortable: true},
      {key: 'soldtoId', label: 'Sold-to', sortable: true},
      {key: 'soldtoName', label: 'Company', sortable: true},

      {key: 'ndaState', label: 'PRA', sortable: true},
      {key: 'status', label: 'Status', sortable: true},
      {key: 'submitDate', label: 'Submit Date', sortable: true},
    ],
  },
  getters: {},
  mutations: {
    requests: (s, a) => (s.requests = isEmpty(a) ? [] : humps.camelizeKeys(a)),
  },
  actions: {
    async fetchRequests({commit, rootState}) {
      try {
        const webkey_id = rootState.webkey.id
        const resp = await api.request.list({webkey_id})

        commit('requests', resp.data)
      } catch (e) {
        commit('requests', [])
      }
    },
  },
}
